@if (battles().length > 0) {
<div class="rb-bar" [class.rb-bar--carousel]="carousel()">
  <div class="rb-bar__head">
    <div class="rb-bar__title ui-label">Recent Battles</div>
  </div>
  <div class="rb-scroller" #scroller (scroll)="onScroll()">
    @for (b of battles(); track b.battleKey) {
    <article class="rb-card" [class.is-me]="involvesMe(b)">
      <div class="rb-row">
        <div class="rb-id">
          <app-pixel-creature [addr]="b.winner.address" [size]="18" />
          <span
            class="rb-name"
            [class.cpu]="b.winner.isCpu"
            [style.color]="b.winner.isCpu ? null : (b.winner.address | addressColor)"
            >{{ displayName(b, b.winner) }}</span
          >
          <span class="rb-badge">W</span>
          @if (b.winner.isCpu) { <span class="tag-cpu">CPU</span> }
        </div>
        @if (b.turnCount !== null) {
        <span class="rb-stat turns">{{ b.turnCount }} turns</span>
        }
      </div>

      <div class="rb-team">
        @for (id of b.winner.monIds; track $index) {
        <app-mon-static-sprite [monId]="id" spriteType="mini" />
        }
      </div>

      <div class="rb-div ui-label">defeats</div>

      <div class="rb-team dim">
        @for (id of b.loser.monIds; track $index) {
        <app-mon-static-sprite [monId]="id" spriteType="mini" />
        }
      </div>

      <div class="rb-row">
        <div class="rb-id">
          <app-pixel-creature [addr]="b.loser.address" [size]="18" />
          <span
            class="rb-name dim"
            [class.cpu]="b.loser.isCpu"
            [style.color]="b.loser.isCpu ? null : (b.loser.address | addressColor)"
            >{{ displayName(b, b.loser) }}</span
          >
          @if (b.loser.isCpu) { <span class="tag-cpu">CPU</span> }
        </div>
        <span class="rb-stat">{{ relativeTime(b.completedAt) }}</span>
      </div>

      <a class="rb-replay" [routerLink]="['/battle', b.battleKey, 'replay']">
        <span class="play"></span> View Replay
      </a>
    </article>
    }
  </div>

  @if (carousel() && battles().length > 1) {
  <div class="rb-carousel-nav">
    <button type="button" class="rb-nav-btn" (click)="step(-1)" aria-label="Previous">‹</button>
    <div class="rb-dots">
      @for (b of battles(); track b.battleKey; let i = $index) {
      <button
        type="button"
        class="rb-dot"
        [class.active]="i === activeIndex()"
        (click)="goTo(i)"
        [attr.aria-label]="'Battle ' + (i + 1)"
      ></button>
      }
    </div>
    <button type="button" class="rb-nav-btn" (click)="step(1)" aria-label="Next">›</button>
  </div>
  }
</div>
}
